import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';

export default function DashboardLayout() {
  // Mobile drawer state. The Sidebar is the ONE nav renderer (desktop rail +
  // mobile drawer), so every role's menu stays a single source of truth
  // (getNavSectionsByRole) — there is no separate mobile list to go stale.
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <div className="flex-1 ml-0 lg:ml-64">
        <TopHeader onMenuClick={() => setMobileNavOpen(true)} />
        <main className="p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}